import cc from "classcat";

const HeaderNavigationPipe = ({ component = "li", className = "" }) => {
	const ComponentToUse = component;

	return (
		<ComponentToUse className={cc(["navigation-pipe align-items-center mx-4", className])}>
			<img
				src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMSAyNCI+CiAgPGxpbmUgaWQ9IkxpbmVfMTgiIGRhdGEtbmFtZT0iTGluZSAxOCIgeDI9IjI0IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjUpIHJvdGF0ZSg5MCkiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzAwMCIgc3Ryb2tlLXdpZHRoPSIxIi8+Cjwvc3ZnPgo="
				alt=""
			/>
		</ComponentToUse>
	);
};

export default HeaderNavigationPipe;
